import React, { useState, useEffect, useRef } from "react";
import {
    MDBTable,
    MDBTableHead,
    MDBTableBody
} from 'mdb-react-ui-kit';
import { Row, Col, Breadcrumb, Card, Form, Table } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import { Image } from 'primereact/image';
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import config from '../config';
import moment from "moment";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import CustomConfirmPopup from "../components/CustomConfirmPopup";
import successVideo from '../assets/video/paperplane.mp4';
import { Dialog } from 'primereact/dialog';
import { Badge } from 'primereact/badge';
import { Link, useNavigate } from 'react-router-dom'; // Assuming React Router is used
import CustomToast from '../components/CustomToast';
import { ToWords } from "to-words";
import InvoiceSearchBar, { EMPTY_INVOICE_SEARCH, toInvoiceSearchParams, hasInvoiceSearch } from "./InvoiceSearchBar";

const Sendinvoice = () => {
    const { accessToken, userId } = useAuth();
    const toastRef = useRef(null);
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
    const [selectedstatusInvoice, setSelectedstatusInvoice] = useState(null);
    const [showstatusDialog, setShowstatusDialog] = useState(false);
    const [approvalStatus, setApprovalStatus] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);
    // State Variables for Search Filters
    const [templateName, setTemplateName] = useState('');
    const [financialYear, setFinancialYear] = useState('');
    const [searchFilters, setSearchFilters] = useState(EMPTY_INVOICE_SEARCH);
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]); // Updated state
    const [pdfUrl, setPdfUrl] = useState(null);
    const [visibleDialog, setVisibleDialog] = useState(false); // State for dialog visibility

    const [years, setYears] = useState([]); // State for storing financial years
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [visible, setVisible] = useState(false);
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [clientId, setClientId] = useState(null);
    const [linkinvoiceId, setLinkinvoiceId] = useState(null);

    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);


    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };


    const getFinancialYearDateRange = (fy) => {
        if (!fy) return null;

        const parts = fy.split("-").map(part => part.trim());
        if (parts.length !== 2) return null;

        let startYear = parseInt(parts[0], 10);
        let endYear = parseInt(parts[1], 10);

        if (isNaN(startYear) || isNaN(endYear)) return null;

        if (startYear < 100) startYear += 2000;
        if (endYear < 100) endYear += 2000;

        return {
            startDate: moment(`${startYear}-04-01`, "YYYY-MM-DD"),
            endDate: moment(`${endYear}-03-31`, "YYYY-MM-DD"),
        };
    };

    const getCurrentFinancialYearRange = () => {
        const today = moment();
        const currentYear = today.year();
        const currentMonth = today.month();
        const startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
        const endYear = startYear + 1;

        return {
            startDate: moment(`${startYear}-04-01`, "YYYY-MM-DD"),
            endDate: moment(`${endYear}-03-31`, "YYYY-MM-DD"),
        };
    };

    const [dateRange, setDateRange] = useState(getCurrentFinancialYearRange());

    const handleDateRangeChange = (start, end) => {
        setDateRange({
            startDate: moment(start),
            endDate: moment(end)
        });
        setPage(1);
    };

    useEffect(() => {
        if (financialYear) {
            const fyRange = getFinancialYearDateRange(financialYear);
            if (fyRange) {
                setDateRange(fyRange);
                setPage(1);
            }
        }
    }, [financialYear]);

    const currencySymbols = {
        INR: "₹ ",
        USD: "$ ",
        GBP: "£ ",
        EUR: "€ ",
        AED: "د.إ ",
        AUD: "A$ ",
        CAD: "C$ "
    };

    const getCurrencySymbol = (currencyCode) => {
        return currencySymbols[currencyCode] || currencyCode; // Default to currency code if not found
    };


    /*------------to-words function --------------*/
    const currencyWordConfig = {
        INR: { name: "Rupee", plural: "Rupees", fraction: "Paisa", fractionPlural: "Paise" },
        USD: { name: "Dollar", plural: "Dollars", fraction: "Cent", fractionPlural: "Cents" },
        EUR: { name: "Euro", plural: "Euros", fraction: "Cent", fractionPlural: "Cents" },
        GBP: { name: "Pound", plural: "Pounds", fraction: "Pence", fractionPlural: "Pence" },
        AED: { name: "Dirham", plural: "Dirhams", fraction: "Fils", fractionPlural: "Fils" },
        AUD: { name: "Australian Dollar", plural: "Australian Dollars", fraction: "Cent", fractionPlural: "Cents" },
        CAD: { name: "Canadian Dollar", plural: "Canadian Dollars", fraction: "Cent", fractionPlural: "Cents" }
    };

    // ⭐ SAME FUNCTION USED IN BOTH PAGES
    const convertAmountToWordsView = (amount, currencyCode) => {
        const c = currencyWordConfig[currencyCode] ?? currencyWordConfig["INR"];

        // Use Indian format only for INR
        const locale = currencyCode === "INR" ? "en-IN" : "en-US";

        const toWords = new ToWords({
            localeCode: locale,
            converterOptions: {
                currency: true,
                ignoreDecimal: false,
                currencyOptions: {
                    name: c.name,
                    plural: c.plural,
                    symbol: currencySymbols[currencyCode],
                    fractionalUnit: {
                        name: c.fraction,
                        plural: c.fractionPlural,
                        symbol: ""
                    }
                }
            }
        });

        return toWords.convert(amount);
    };


    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/fetch-all-templates`, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });

                if (response.status === 200 && response.data.data.length > 0) {
                    setTemplates(response.data.data);
                } else {
                    setTemplates([]);
                }
            } catch (error) {
                console.error('Error fetching templates:', error);
            }
        };

        fetchTemplates();
    }, [accessToken]);

    const openDialog = (invoiceId) => {
        setSelectedInvoiceId(invoiceId);
        setShowDialog(true);
    };




    const handleTemplateChange = (event) => {
        const selectedId = event.target.value; // Get selected template_id
        const selected = templates.find((template) => template.template_id.toString() === selectedId);
        setSelectedTemplate(selected || null);
    };


    const handleSave = async () => {
        if (!selectedTemplate || !selectedInvoiceId) return;
        setShowDialog(false);
        await duplicateInvoice(selectedInvoiceId, selectedTemplate);
    };





    const fetchFinancialYears = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/unique-financial-years`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            const fetchedYears = response.data.financial_years;
            setYears(fetchedYears);

            // Automatically select the last (most recent) year by default
            if (fetchedYears.length > 0) {
                const sortedYears = [...fetchedYears].sort((a, b) => {
                    const aStart = parseInt(a.split("-")[0], 10);
                    const bStart = parseInt(b.split("-")[0], 10);
                    return aStart - bStart;
                });

                setYears(sortedYears);
                setFinancialYear(sortedYears[sortedYears.length - 1]);
            } else {
                setYears([]);
            }
        } catch (error) {
            console.error("Error fetching financial years:", error);
        }
    };
    useEffect(() => {
        fetchFinancialYears();
    }, [accessToken]); // Run once on mount

    // Fetch Invoices Function
    const fetchSentInvoices = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/fetch-sent-invoices`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: {
                    page,
                    limit,
                    template_name: templateName,
                    financial_year: financialYear,
                    ...toInvoiceSearchParams(searchFilters),
                    startDate: dateRange.startDate.format("YYYY-MM-DD"),
                    endDate: dateRange.endDate.format("YYYY-MM-DD"),
                }
            });

            setInvoices(response.data.data || []);
            setTotalPages(response.data.totalPages || 0);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        }
        setLoading(false);
    };


    // Fetch data when component mounts or filters change
    useEffect(() => {
        fetchSentInvoices();
    }, [page, templateName, financialYear, dateRange, searchFilters]);




    // Function to handle selecting/unselecting all checkboxes
    const handleSelectAll = (e) => {
        if (e.checked) {
            setSelectedInvoiceIds(invoices.map(invoice => invoice.invoice_id)); // Select all
        } else {
            setSelectedInvoiceIds([]); // Deselect all
        }
    };

    // Function to handle selecting/unselecting a specific invoice
    const handleSelectInvoice = (invoiceId) => {
        setSelectedInvoiceIds(prevSelected =>
            prevSelected.includes(invoiceId)
                ? prevSelected.filter(id => id !== invoiceId) // Remove if already selected
                : [...prevSelected, invoiceId] // Add if not selected
        );
    };


    // Restore Invoice Function
    const restoreInvoice = async (invoice) => {
        try {
            const newStatus = invoice.status === "Sent" ? "Cancelled" : "Sent"; // Toggle status

            await axios.put(
                `${config.apiBASEURL}/InvoiceRoutes/update-invoice-status`,
                { invoice_id: invoice.invoice_id, new_status: newStatus }, // Toggle status dynamically
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            fetchSentInvoices(); // Refresh list after updating status
        } catch (error) {
            console.error("Error updating invoice status:", error);
        }
    };



    const duplicateInvoice = async (invoiceId, template) => {
        setLoading(true); // Show loader

        try {
            const response = await axios.post( // Changed to POST since duplication is not usually a DELETE operation
                `${config.apiBASEURL}/InvoiceRoutes/duplicate/${invoiceId}`,
                {
                    template_id: template.template_id,
                    template_name: template.template_name,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                setLoading(false); // Stop loading
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 5 seconds
                    fetchSentInvoices(); // Refresh invoice list after duplication
                }, 3000);
            }
        } catch (error) {
            console.error("Error duplicating invoice:", error);
        } finally {
            setLoading(false); // Hide loader
        }
    };



    const ReSendInvoice = async (invoiceId) => {
        setLoading(true); // Show loader

        try {
            const response = await axios.post( // Changed to POST since duplication is not usually a DELETE operation
                `${config.apiBASEURL}/InvoiceRoutes/resend-invoice`,
                { invoice_id: invoiceId },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                fetchSentInvoices(); // Refresh invoice list after duplication
            }
        } catch (error) {
            console.error("Error duplicating invoice:", error);
        } finally {
            setLoading(false); // Hide loader
        }
    };



    const handleGenerateInvoicesPDF = async () => {
        if (selectedInvoiceIds.length === 0) {
            showMessage('error', 'No PDF Selected for Download');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${config.apiBASEURL}/InvoiceRoutes/generate-multiple-invoices`,
                {
                    invoice_ids: selectedInvoiceIds,
                    user_id: userId, // Pass the user ID
                    templateName,
                    financialYear,
                    billingName: searchFilters.client,
                    startDate: dateRange.startDate.format("DD-MM-YYYY"),
                    endDate: dateRange.endDate.format("DD-MM-YYYY"),
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`, // Include authentication token
                    },
                }
            );

            if (response.status === 200) {
                showMessage('success', 'PDF has been subjected to download and will be available in your Downloads section shortly.');
                setSelectedInvoiceIds([]); // Deselect all
            }
        } catch (error) {
            console.error("Error generating invoices:", error);
            setLoading(false); // Hide loader
        } finally {
            setLoading(false);
        }
    };



    const handleGenerateInvoicesAllPDF = async () => {
        // Check if at least one filter is filled
        // Normalize values (trim & treat "All" or "Select" as empty optional)
        const filterValues = [
            templateName?.trim(),
            financialYear?.trim()
        ].filter(value => value && value !== "All" && value !== "Select");

        // If nothing meaningful exists → block
        if (filterValues.length === 0 && !hasInvoiceSearch(searchFilters)) {
            showMessage('warn', "Please select at least one filter before downloading invoices.");
            return;
        }
        setLoading(true);

        try {
            const response = await axios.post(
                `${config.apiBASEURL}/InvoiceRoutes/downloadallinvoices`,
                {
                    user_id: userId, // Pass the user ID
                    template_name: templateName,
                    financial_year: financialYear,
                    ...toInvoiceSearchParams(searchFilters),
                    startDate: dateRange.startDate.format("YYYY-MM-DD"),
                    endDate: dateRange.endDate.format("YYYY-MM-DD"),
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`, // Include authentication token
                    },
                }
            );

            if (response.status === 200) {
                showMessage('success', 'PDF has been subjected to download and will be available in your Downloads section shortly.');
                setSelectedInvoiceIds([]); // Deselect all
            }
        } catch (error) {
            console.error("Error generating invoices:", error);
            showMessage('error', error.response?.data?.message || 'Failed to start the invoice download.');
            setLoading(false); // Hide loader
        } finally {
            setLoading(false);
        }
    };




    useEffect(() => {
        if (visible && clientId) {
            fetchProjects(clientId);
        }
    }, [visible, clientId]);

    const fetchProjects = async (clientId) => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/client-projects/${clientId}`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            setProjects(response.data.data);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };


    const handleLinkProject = async () => {
        if (!selectedProject) return;
        setLoading(true); // Show loader
        try {
            await axios.put(`${config.apiBASEURL}/InvoiceRoutes/associate_invoice_with_project`, {
                invoiceId: linkinvoiceId,
                Client_Project_id: selectedProject.Client_Project_id,
                form_submission_id: selectedProject.formSubmission?.form_submission_id
            }, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            setVisible(false);
            setLinkinvoiceId(null);
            setSelectedProject(null);
            setLoading(false); // Stop loading
            setVideoDialogVisible(true);
            setTimeout(() => {
                setVideoDialogVisible(false); // Hide video dialog after 5 seconds
                fetchSentInvoices(); // Refresh invoice list after duplication
            }, 3000);
        } catch (error) {
            console.error('Error linking project:', error);

        }
        finally {
            setLoading(false); // Hide loader
        }
    };

    const getBadgeSeverity = (status) => {
        switch (status) {
            case 'Accepted':
                return 'success'; // Green badge
            case 'Rejected':
                return 'danger'; // Red badge
            case 'Needs_approval':
                return 'warning'; // Yellow badge
            default:
                return 'info'; // Default blue badge
        }
    };

    const getPaymentBadgeSeverity = (status) => {
        switch (status) {
            case 'Payment_due':
                return 'danger'; // Red badge
            case 'Payment_Completed':
                return 'success'; // Green badge
            case 'Partial_Payment':
                return 'warning'; // Yellow badge
            case 'Refunded':
                return 'info'; // Blue badge
            case 'Not_Applicable':
                return 'secondary'; // Gray badge for Quotations & PI
            default:
                return 'secondary'; // Gray badge (fallback)
        }
    };


    const approvalOptions = ["Accepted", "Rejected", "Needs_approval"];
    const paymentOptions = ["Payment_due", "Payment_Completed", "Partial_Payment", "Refunded", "Not_Applicable"];


    const openstatusDialog = (invoice) => {
        setSelectedstatusInvoice(invoice);
        setApprovalStatus(invoice.Approval_status);
        setPaymentStatus(invoice.Payment_status);
        setShowstatusDialog(true);
    };


    const handleUpdate = async () => {

        setLoading(true);
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/InvoiceRoutes/invoice/${selectedstatusInvoice.invoice_id}/approval`,
                {
                    approval_status: approvalStatus,
                    payment_status: paymentStatus,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                setVideoDialogVisible(true); // Show video dialog
                setShowstatusDialog(false);
                setSelectedstatusInvoice(null);
                setApprovalStatus(null);
                setPaymentStatus(null);
                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 5 seconds
                    fetchSentInvoices(); // Refresh invoice list after duplication
                }, 3000);
            }
        } catch (error) {
            console.error("Error updating invoice:", error);

        }
        finally {
            setLoading(false); // Hide loader
        }
    };



    const DownloadSingleInvoice = async (invoiceId) => {
        if (!invoiceId) {
            showMessage('error', 'Invalid Invoice ID');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${config.apiBASEURL}/InvoiceRoutes/generate-single-invoice`,
                {
                    invoice_id: invoiceId,
                    user_id: userId,
                    templateName,
                    financialYear,
                    billingName: searchFilters.client,
                    startDate: dateRange.startDate.format("DD-MM-YYYY"),
                    endDate: dateRange.endDate.format("DD-MM-YYYY"),
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                showMessage('success', 'Invoice is being processed and will be available in your Downloads section shortly.');
            }
        } catch (error) {
            console.error("Error generating single invoice:", error);
            showMessage('error', 'Failed to process invoice download. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <>

            <InvoiceSearchBar
                showStatusFilters
                onChange={(filters) => {
                    setSearchFilters(filters);
                    setPage(1);
                }}
            >
                    <div>
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-search" />
                            <Form.Select
                                value={templateName}
                                onChange={(e) => {
                                    setTemplateName(e.target.value);
                                    setPage(1);
                                }}
                                className='border-0 border-bottom ps-5 respWidth'
                                style={{ width: '180px' }}
                            >
                                <option value="">Select Template</option>
                                {templates.map(template => (
                                    <option key={template.template_id} value={template.header_text}>
                                        {template.template_name} / {template.invoice_prefix} / {template.financial_year}
                                    </option>
                                ))}
                            </Form.Select>

                        </IconField>
                    </div>

                    <div>
                        <Form.Select
                            value={financialYear}
                            onChange={(e) => setFinancialYear(e.target.value)}
                            className="border-0 border-bottom  respWidth"
                            style={{ width: "180px" }}
                        >
                            <option value="">Select Year</option>
                            {years.map((year, index) => (
                                <option key={index} value={year}>{year}</option>
                            ))}
                        </Form.Select>
                    </div>
                    <div>
                        <DateRangePicker
                            key={`${financialYear}-${dateRange.startDate.format("YYYY-MM-DD")}-${dateRange.endDate.format("YYYY-MM-DD")}`}
                            initialSettings={{
                                startDate: dateRange.startDate,
                                endDate: dateRange.endDate,
                                locale: { format: "DD/MM/YYYY" },
                                ranges: {
                                    Today: [moment(), moment()],
                                    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                                    "Last Month": [
                                        moment().subtract(1, "month").startOf("month"),
                                        moment().subtract(1, "month").endOf("month"),
                                    ],
                                },
                            }}
                            onCallback={(start, end) => handleDateRangeChange(start, end)}
                        >
                            <input
                                type="text"
                                className="form-control mx-2 respWidth"
                                style={{ width: "200px" }}
                                value={`${dateRange.startDate.format("DD/MM/YYYY")} - ${dateRange.endDate.format("DD/MM/YYYY")}`}
                                readOnly
                                placeholder="Select Date Range"
                            />
                        </DateRangePicker>

                    </div>
                    <Button
                        title={loading ? "Generating..." : "Download Selected Invoices"}
                        icon="pi pi-download"
                        severity="help"
                        className="me-2 py-2"
                        onClick={handleGenerateInvoicesPDF}
                        disabled={loading}
                    />

                    <CustomConfirmPopup
                        message={loading ? "Generating... Please wait." : "Are you sure you want to Download All Invoices?"}
                        icon="pi pi-cloud-download"
                        defaultFocus="accept"
                        acceptClassName="p-button-danger"
                        buttonLabel={loading ? "Generating..." : "Download"}
                        title="Download All Invoices"
                        buttonClass={`p-button-danger cancbtn ${loading ? "p-disabled" : ""}`}
                        className="me-2 py-2"
                        buttonIcon={loading ? "pi pi-spin pi-spinner" : "pi pi-cloud-download"}
                        onConfirm={handleGenerateInvoicesAllPDF}
                        onReject={() => console.log('Download canceled')}
                    />
            </InvoiceSearchBar>
            <div className="sendINV_scrolltable">
                <MDBTable responsive hover className='Departtable'>
                    <MDBTableHead className="sticky-top" style={{ backgroundColor: '#e1ebff' }}>
                        <tr>
                            <th scope='col' style={{ width: '50px' }}>
                                {/* <Checkbox
                                    onChange={handleSelectAll}
                                    checked={selectedInvoiceIds.length === invoices.length && invoices.length > 0}
                                /> */}
                            </th>
                            <th scope='col'>Invoice Id</th>
                            <th scope='col'>Client</th>
                            <th scope='col'>DESC</th>
                            <th scope='col'>Currency</th>
                            <th scope='col'> Date</th>
                            <th scope='col'>Amount</th>
                            <th scope='col'>Payment <sub>Status</sub></th>
                            <th scope='col'>Action</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {loading ? (
                            <tr>
                                <td colSpan="9" className="text-center">Loading...</td>
                            </tr>
                        ) : invoices.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="text-center">No invoices found</td>
                            </tr>
                        ) : (
                            invoices.map((invoice) => (
                                <tr key={invoice.invoice_id} className={invoice.status === "Cancelled" ? "cancelled" : ""}>
                                    <td>
                                        <Checkbox
                                            onChange={() => handleSelectInvoice(invoice.invoice_id)}
                                            checked={selectedInvoiceIds.includes(invoice.invoice_id)}
                                            style={{ position: "relative", zIndex: "4" }}
                                        />
                                    </td>
                                    <td>{invoice.invoice_code}
                                        <span className="d-block">
                                            <p className="m-0"><small>Client Approval: </small>
                                                <br />
                                                <Badge
                                                    value={invoice.Approval_status}
                                                    severity={getBadgeSeverity(invoice.Approval_status)}
                                                />
                                            </p>
                                        </span>
                                    </td>
                                    <td>
                                        <Link to={`/Graphe/dashboard/view_client/${invoice.specificInvoices?.Client_id}`} >
                                            {invoice.specificInvoices?.bill_name}
                                        </Link>
                                        <span className="d-block">
                                            <Button
                                                className="p-button-sm p-0"
                                                icon="pi pi-phone"
                                                rounded
                                                text
                                                severity="success"
                                                tooltip={invoice.specificInvoices?.phone}
                                                tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            />
                                            <Button
                                                className="p-button-sm p-0"
                                                icon="pi pi-envelope"
                                                rounded
                                                text
                                                severity="primary"
                                                tooltip={invoice.specificInvoices?.email}
                                                tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            />
                                        </span>
                                    </td>
                                    <td>
                                        <p className="m-0"><small> </small> {invoice.template_name}</p>
                                        <p className="m-0"><small> </small> {invoice.remarks}</p>
                                    </td>
                                    <td>{invoice.currency}</td>

                                    <td>
                                        <p className="m-0"><small>Issue Date:  {new Date(invoice.issue_date).toLocaleDateString('en-GB')}</small> </p>
                                        <p className="m-0"><small className="text-danger">Due Date:    {invoice.due_date
                                            ? new Date(invoice.due_date).toLocaleDateString("en-GB")
                                            : "—"}</small></p>
                                        {invoice.sent_on && (
                                            <p className="m-0">
                                                <small className="text-success">
                                                    Last Sent Date: {new Date(invoice.sent_on).toLocaleDateString('en-GB')}
                                                </small>
                                            </p>
                                        )}

                                    </td>


                                    <td>
                                        <p className="m-0"><small>Cost: </small> <b>{invoice.sub_total}</b></p>
                                        {invoice.lut ? (
                                            <p className="m-0"><small>LUT ARN No: </small> <b>{invoice.Lut_Arn_No}</b></p>
                                        ) : (
                                            <>
                                                <p className="m-0"><small>Tax Type: </small> <b>{invoice.tax_type}</b></p>
                                                <p className="m-0"><small>Tax: </small> <b>{invoice.tax}</b></p>
                                            </>
                                        )}
                                        <p className="m-0"><small>Total: </small> <b>{invoice.total}</b></p>
                                    </td>
                                    <td>
                                        <p className="m-0">

                                            <Badge
                                                value={invoice.Payment_status.replace(/_/g, ' ')}
                                                severity={getPaymentBadgeSeverity(invoice.Payment_status)}
                                            />
                                        </p>
                                    </td>
                                    <td className="">

                                        <Button
                                            icon="pi pi-eye"
                                            rounded
                                            text
                                            severity="secondary"
                                            aria-label="Bookmark"
                                            tooltip="View"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            onClick={() => {
                                                setSelectedInvoice(invoice); // Set the selected invoice
                                                setVisibleRight(true); // Show the sidebar/modal
                                            }}
                                        />
                                        <Button
                                            icon="pi pi-file-edit"
                                            rounded
                                            text
                                            aria-label="Filter"
                                            severity="help"
                                            tooltip="Edit"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            onClick={() => navigate(`/Graphe/dashboard/edit_invoice/${invoice.invoice_id}`)}
                                        />
                                        <Button
                                            icon="pi pi-link"
                                            rounded
                                            text
                                            aria-label="Filter"
                                            severity="info"
                                            tooltip="Link"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            onClick={() => {
                                                setVisible(true);
                                                setClientId(invoice.Client_id);
                                                setLinkinvoiceId(invoice.invoice_id);
                                            }}
                                        />

                                        <Button

                                            icon="pi pi-wrench"
                                            onClick={() => openstatusDialog(invoice)}
                                            rounded
                                            text
                                            aria-label="Filter"
                                            severity="warning"
                                            tooltip="Status Change"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                        />


                                        <Button

                                            icon="pi pi-clone"
                                            onClick={() => openDialog(invoice.invoice_id)}
                                            rounded
                                            text
                                            aria-label="Filter"
                                            severity="warning"
                                            tooltip="Duplicate Invoice"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                        />



                                        <CustomConfirmPopup
                                            message="Are you sure you want to Download this Invoice?"
                                            icon="pi pi-exclamation-triangle"
                                            defaultFocus="accept"
                                            acceptClassName="p-button-success"
                                            buttonLabel="Download"
                                            title="Download Invoice"
                                            buttonClass="p-button-success p-button-text cancbtn"
                                            className="border-0 p-0"
                                            buttonIcon="pi pi-download"
                                            onConfirm={() => DownloadSingleInvoice(invoice.invoice_id)}
                                            onReject={() => console.log('ReSend action canceled')}
                                        />


                                        <CustomConfirmPopup
                                            message="Are you sure you want to ReSend this Invoice?"
                                            icon="pi pi-exclamation-triangle"
                                            defaultFocus="accept"
                                            acceptClassName="p-button-success"
                                            buttonLabel="ReSend"
                                            title="ReSend Invoice"
                                            buttonClass="p-button-success p-button-text"
                                            className="border-0 p-0"
                                            buttonIcon="pi pi-file-export"
                                            onConfirm={() => ReSendInvoice(invoice.invoice_id)}
                                            onReject={() => console.log('ReSend action canceled')}
                                        />





                                        <CustomConfirmPopup
                                            message={invoice.status === "Sent" ? "Are you sure you want to cancel this Invoice?" : "Are you sure you want to undo the cancellation?"}
                                            icon="pi pi-exclamation-triangle"
                                            defaultFocus="accept"
                                            acceptClassName="p-button-danger"
                                            buttonLabel={invoice.status === "Sent" ? "Cancel Invoice" : "Undo Cancel"}
                                            title={invoice.status === "Sent" ? "Cancel Invoice" : "Undo Cancel"}
                                            buttonClass="p-button-danger p-button-text cancbtn"
                                            className="border-0 p-0"
                                            buttonIcon={invoice.status === "Sent" ? "pi pi-ban" : "pi pi-undo"}
                                            onConfirm={() => restoreInvoice(invoice)}
                                            onReject={() => console.log('Action canceled')}
                                        />






                                    </td>
                                </tr>
                            ))
                        )}
                    </MDBTableBody>
                </MDBTable>
            </div>
            <div className="pagination_sendinv pt-4 text-center">
                <Button
                    label="Previous"
                    icon="pi pi-angle-left"
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                    className="p-0"
                    text
                    severity="danger"
                />

                <span className="mx-3">Page {page} of {totalPages}</span>

                <Button
                    label="Next"
                    icon="pi pi-angle-right"
                    iconPos="right"
                    disabled={page === totalPages}
                    onClick={() => setPage(page + 1)}
                    className="p-0"
                    text
                    severity="danger"
                />
            </div>

            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} className="resp_sidewidth" style={{ width: '50vw' }}>
                {selectedInvoice && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '0', fontFamily: 'Roboto', background: '#fff' }}>
                        <thead className={selectedInvoice?.status === "Cancelled" ? "cancelINV" : ""}>
                            <tr style={{ borderBottom: '1px solid #ddd' }}>
                                <td colspan="3" style={{ padding: '10px', Width: '300px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={selectedInvoice.logo_url || require("../assets/images/logo.png")} alt="Company Logo" style={{ height: '170px', width: '170px', objectFit: 'contain' }} />
                                        <div style={{ width: 'calc(100% - 120px)', marginLeft: '30px' }}>
                                            <h2 style={{ margin: '5px 0 0 0', fontSize: '20px', color: '#494949', textTransform: 'uppercase' }}>The Graphē</h2>
                                            <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: '400', color: '#858585' }}>A Design Studio</p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', lineHeight: '20px', color: '#494949', width: '200px' }}>{selectedInvoice.template?.company_address || "N/A"}</p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>GSTIN No. : <b>{selectedInvoice.template?.GSTIN}</b></p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>MSME No. : <b>{selectedInvoice.MSME_Number}</b> <small style={{ color: '#858585' }}>({selectedInvoice.MSME_Type})</small></p>
                                            {selectedInvoice.lut && (<p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>LUT No. : <b>{selectedInvoice.Lut_Arn_No}</b></p>)}
                                        </div>
                                    </div>
                                </td>
                                <td style={{ padding: "10px", textAlign: "right", verticalAlign: "top", width: "280px", paddingLeft: "65px" }} colspan="2" >
                                    <h3 style={{ margin: "5px 0 10px 0", fontSize: "26px", color: "#000" }}>{selectedInvoice.template_name}</h3>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" style={{ padding: "8px 0" }}></td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ padding: "10px 15px 10px 10px", verticalAlign: "top" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Bill To :</p>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.bill_name}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Poc : </span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.poc}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Email : </span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.email || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.phone || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>GSTIN :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.gstin || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.bill_address || "N/A"}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td colSpan="2" style={{ padding: "10px", verticalAlign: "top" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Ship To :</p>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.shipping_name}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.shipping_phone}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", lineHeight: "1.3", marginTop: "5px" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)", }}>
                                                {selectedInvoice.shipping_address}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td colSpan="1" style={{ padding: "10px", verticalAlign: "top", width: "200px" }}>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Invoice # :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {selectedInvoice.invoice_code}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Issue Date :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {new Date(selectedInvoice.issue_date).toLocaleDateString("en-GB")}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Due Date :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                               {selectedInvoice.due_date
                                                    ? new Date(selectedInvoice.due_date).toLocaleDateString("en-GB")
                                                    : "—"}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5" style={{ padding: '10px 0' }}></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ backgroundColor: '#e7e7e7', textAlign: 'left' }}>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '230px' }}>Description</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>SAC/HSN</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Rate</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Qty</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '100px' }}>Sub Total</th>
                            </tr>
                            {selectedInvoice?.invoiceProducts?.map((product, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        <span style={{ display: 'block', marginBottom: '3px' }}>{index + 1}. {product.description}</span>
                                        {product.Remarks && (
                                            <small style={{ fontSize: '11px', lineHeight: '1.2' }} className="text-secondary d-block">
                                                <b>Remarks :</b> {product.Remarks}
                                            </small>
                                        )}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {product.hsn ? `HSN-${product.hsn}` : product.sac_code ? `SAC-${product.sac_code}` : '-'}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {getCurrencySymbol(selectedInvoice.currency)} {product.price}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>{product.quantity}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {getCurrencySymbol(selectedInvoice.currency)} {product.subtotal_price}
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <th colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Subtotal:</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.sub_total}</th>
                            </tr>
                            {selectedInvoice.tax_type === "Cgst+Sgst" && (
                                <>
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>CGST ({selectedInvoice.cgst}%):</td>
                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.cgst_value.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>SGST ({selectedInvoice.sgst}%):</td>
                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.sgst_value.toFixed(2)}</td>
                                    </tr>
                                </>
                            )}
                            {selectedInvoice.tax_type === "Igst" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>IGST ({selectedInvoice.igst}%):</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.igst_value.toFixed(2)}</td>
                                </tr>
                            )}
                            {selectedInvoice.tax_type === "GST" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>GST ({selectedInvoice.gst}%):</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.gst_value.toFixed(2)}</td>
                                </tr>
                            )}
                            {selectedInvoice.supplyAttractReverses === "Yes" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Supply Attract Reverse Charge :</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Yes</td>
                                </tr>
                            )}
                            <tr style={{ backgroundColor: '#e7e7e7' }}>
                                <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '18px' }}>Total:</td>
                                <td style={{ border: '1px solid #ddd', fontWeight: '600', padding: '6px 10px', fontSize: '18px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.total}</td>
                            </tr>
                            <tr>
                                {/* <td colSpan={5} style={{ padding: '10px 10px 10px 0' }}>
                                    <p style={{ margin: 0, fontSize: '13px' }}>
                                        Total amount (in words) : <span style={{ fontWeight: '500', paddingLeft: '5px' }}>{selectedInvoice.currency} {toWords(selectedInvoice.total).replace(/-/g, ' ').toUpperCase()} ONLY.</span>
                                    </p>
                                </td> */}
                                <td colSpan={5} style={{ padding: '10px 10px 10px 0' }}>
                                    <p style={{ margin: 0, fontSize: '13px' }}>
                                        Total amount (in words) :
                                        <span style={{ fontWeight: '500', paddingLeft: '5px' }}>
                                            {selectedInvoice.currency} {convertAmountToWordsView(selectedInvoice.total, selectedInvoice.currency).toUpperCase()}.
                                        </span>
                                    </p>
                                </td>
                            </tr>
                            {selectedInvoice.remarks && (
                                <tr>
                                    <td colSpan={5} style={{ padding: '10px 10px 10px 0', verticalAlign: 'top' }}>
                                        <p style={{ margin: 0 }}>
                                            <span style={{ fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>Remarks :</span>
                                            <span style={{ fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>{selectedInvoice.remarks}</span>
                                        </p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="5" style={{ padding: "10px 0" }}></td>
                            </tr>
                            <tr>
                                <td colSpan="3" style={{ padding: "15px 10px", verticalAlign: "top", borderTop: "1px solid #ddd" }}>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ paddingRight: "10px", textAlign: "center" }}>
                                            <p style={{ margin: "0 0 6px 0", fontSize: "12px", fontWeight: 600 }}>Pay Using UPI :</p>
                                            <img
                                                src="https://ik.imagekit.io/blackboxv2/Graphe-logo/Graphe%CC%84%20QR%20Code.png?updatedAt=1743494152821"
                                                alt="UPI QR Code"
                                                style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                            />
                                            <small style={{ display: "block", fontSize: "12px", fontWeight: 400 }}>
                                                yashashwi.malani@okhdfcbank
                                            </small>
                                        </div>

                                        <div style={{ width: "calc(100% - 120px)", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                                            <p style={{ margin: "0 0 6px 0", fontSize: "13px", fontWeight: 600 }}>Bank Details :</p>
                                            <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                                <li style={{ display: "flex", marginBottom: "3px" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C Name :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)", lineHeight: 1.3 }}>
                                                        {selectedInvoice.template?.company_name || "N/A"}
                                                        <small style={{ margin: "2px 0 0px 0", fontSize: "11px", fontWeight: 400, color: "#858585", display: "block" }}>
                                                            Pay By CHEQUE/DD/RTGS/NEFT
                                                        </small>
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Bank :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.bank_name || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C NO :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.account_number || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>IFSC :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.ifsc_code || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Branch :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.bank_branch || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Swift Code :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.swift_code || "N/A"}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                                <td style={{ padding: "15px 10px", textAlign: "right", verticalAlign: "top", borderTop: "1px solid #ddd" }} colSpan="2">
                                    <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                                        <div>
                                            <small style={{ marginRight: "50px" }}>
                                                <img
                                                    src="https://ik.imagekit.io/blackboxv2/Graphe-logo/stamp.jpeg?updatedAt=1737015027907"
                                                    alt="Stamp"
                                                    style={{ width: "80px", height: "80px", objectFit: "contain" }}
                                                />
                                            </small>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <p style={{ display: "block", fontSize: "14px", margin: "0 0 18px 0", fontWeight: 500 }}>
                                                <small>For The Graphē</small>
                                            </p>
                                            <img src={selectedInvoice.signature_url} alt="Signature" style={{ width: "80px", height: "80px" }} />
                                            <p style={{ display: "block", fontSize: "14px", margin: "18px 0 0 0", fontWeight: 400 }}>
                                                <small>Authorised Signatory</small>
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ backgroundColor: "#f7f7f7" }}>
                                <td colSpan="5" style={{ padding: "10px 10px 0 10px", color: "#575757" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "13px", fontWeight: 600 }}>
                                        <span>Terms and Conditions : </span>
                                    </p>
                                    {[
                                        "Payment: Due within 7 days. Late payments attract interest as per the MSME Act, 2006.",
                                        "Interest on Late Payment: As per Section 16 of the MSME Act, 2006, delays beyond 45 days from the invoice date will attract interest at *24% P.A*",
                                        "Intellectual Property: Final designs are transferred upon full payment. Unpaid concepts remain the agency’s property.",
                                        "For 194(C),TDS under new Secion at 2% under Section 393(1)-Table Sl No.6(iii)D(a) : Code-1026.",
                                        "For 194(J),TDS under new Secion at 10% under Section 393(1)-Table Sl No.6(iii)D(b) : Code-1027.",
                                        "Taxes: GST applicable as per law. Any tax changes are the client’s responsibility.",
                                        "Payment: 50% advance before initiation of project and balance before final deliverables.",
                                        "Jurisdiction: Disputes fall under Kolkata, West Bengal, jurisdiction.",
                                        "A valid purchase order or work order is required for the commencement of the project."
                                    ].map((text, index) => (
                                        <p key={index} style={{ margin: "0 0 5px 0", fontSize: "12px", fontWeight: 400 }}>{index + 1}. {text}</p>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" style={{ backgroundColor: "#313030", padding: "10px 15px", textAlign: "center" }}>
                                    <small style={{ fontSize: "13px", fontWeight: 400, color: "#fff" }}>
                                        Call: {selectedInvoice.template?.contact_no || "N/A"} &nbsp;| &nbsp;
                                        Email: <a href={`mailto:${selectedInvoice.template?.email}`} style={{ color: "#fff" }}>{selectedInvoice.template?.email || "N/A"}</a>
                                    </small>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </Sidebar>


            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>
            {/* <Dialog
                header="Invoice PDF"
                visible={visibleDialog}
                onHide={() => setVisibleDialog(false)}
                style={{ width: '320px' }}
            >
                {pdfUrl && (

                    <div >
                        <p className="text-center">Invoice PDF generated successfully.</p>
                        <div className="d-flex justify-content-between ">
                            <a className="btn btn-info" href={pdfUrl} target="_blank" rel="noopener noreferrer">
                                Open PDF
                            </a>
                        </div>
                    </div>
                )}
            </Dialog> */}


            <Dialog header="Link Project" visible={visible} onHide={() => setVisible(false)}>
                <div>
                    <Dropdown
                        value={selectedProject}
                        options={projects}
                        onChange={(e) => setSelectedProject(e.value)}
                        optionLabel="project_name"
                        placeholder="Select a Project"
                    />
                    {selectedProject && (
                        <div className="mt-3">
                            <p className="mb-0" style={{ fontSize: '13px' }}><small className="d-block text-secondary mt-2">Client Project Name:</small> {selectedProject.project_name}</p>
                            <p className="mb-0" style={{ fontSize: '13px' }}><small className="d-block text-secondary mt-2">Form Name:</small> {selectedProject.formSubmission?.form_name}</p>
                            <p className="mb-0" style={{ fontSize: '13px' }}><small className="d-block text-secondary mt-2">Submission Status:</small> {selectedProject.formSubmission?.submission_status}</p>
                        </div>
                    )}
                    <Button label="Link Project" icon="pi pi-check" onClick={handleLinkProject} className="mt-4 py-2" />
                </div>
            </Dialog>


            <Dialog
                header="Select Template"
                visible={showDialog}
                style={{ width: "350px" }}
                onHide={() => setShowDialog(false)}
            >
                <Form.Group className="mb-3">
                    <Form.Select onChange={handleTemplateChange} value={selectedTemplate?.template_id || ""}>
                        <option disabled value="">Select Template</option>
                        {templates.length > 0 ? (
                            templates.map((template) => (
                                <option key={template.template_id} value={template.template_id}>
                                    {template.template_name} / {template.invoice_prefix} / {template.financial_year}
                                </option>
                            ))
                        ) : (
                            <option disabled>No Templates Available</option>
                        )}
                    </Form.Select>

                </Form.Group>

                <div className="d-flex justify-content-end gap-2">
                    <Button label="Cancel" className="p-button-text" onClick={() => setShowDialog(false)} />
                    <Button
                        label="Select"
                        className="p-button-primary"
                        onClick={handleSave}
                        disabled={!selectedTemplate}
                    />
                </div>
            </Dialog>


            <Dialog
                header="Update Invoice Status"
                visible={showstatusDialog}
                style={{ width: "350px" }}
                onHide={() => setShowstatusDialog(false)}
            >
                <div className="p-field">
                    <label>Approval Status</label>
                    <Dropdown
                        value={approvalStatus}
                        options={approvalOptions}
                        onChange={(e) => setApprovalStatus(e.value)}
                        placeholder="Select Approval Status"
                    />
                </div>
                <div className="p-field">
                    <label>Payment Status</label>
                    <Dropdown
                        value={paymentStatus}
                        options={paymentOptions}
                        onChange={(e) => setPaymentStatus(e.value)}
                        placeholder="Select Payment Status"
                    />
                </div>
                <div className="d-flex justify-content-end gap-2 mt-2">
                    <Button label="Cancel" className="p-button-text" onClick={() => setShowstatusDialog(false)} />
                    <Button label="Update" onClick={handleUpdate} loading={loading} />
                </div>
            </Dialog>

            <CustomToast ref={toastRef} />
        </>
    );
};

export default Sendinvoice;